import { createContext, FC, useCallback, useState } from "react";
import ConfirmModal, {
  ConfirmModalProps,
} from "../Modals/ConfirmModal/ConfirmModal";
import { emptyFn } from "../../../utils";

type SetConfirmModalData = (
  confirmModalData: Partial<Omit<ConfirmModalProps, "isOpen">>
) => void;

export const ConfirmModalContext = createContext<SetConfirmModalData>(emptyFn);

const ConfirmModalProvider: FC = ({ children }) => {
  const [confirmData, setConfirmData] = useState<ConfirmModalProps>({
    isOpen: false,
    onClose: emptyFn,
  });

  const setConfirmModalData = useCallback<SetConfirmModalData>(
    (confirmModalData) => {
      const defaultOnClose = () =>
        setConfirmData((prev) => ({ ...prev, isOpen: false }));
      setConfirmData({
        isOpen: true,
        onClose: defaultOnClose,
        ...confirmModalData,
      });
    },
    []
  );

  return (
    <ConfirmModalContext.Provider value={setConfirmModalData}>
      {children}
      {confirmData.isOpen && <ConfirmModal {...confirmData} />}
    </ConfirmModalContext.Provider>
  );
};

export default ConfirmModalProvider;
